import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enContent from '@/locales/en/content.json'
import enFaq from '@/locales/en/faq.json'
import ruContent from '@/locales/ru/content.json'
import ruFaq from '@/locales/ru/faq.json'

export const DEFAULT_LANGUAGE = 'ru'

export const ALL_LANGUAGES = [DEFAULT_LANGUAGE, 'en'] as const

i18n.use(initReactI18next).init({
  resources: {
    ru: {
      translation: { ...ruContent, faq: ruFaq },
    },
    en: {
      translation: { ...enContent, faq: enFaq },
    },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
